/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Up Arrow Icon component.
 */
export const UpArrowIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M11.1912 6.38237L7.51969 3L4 6.38237' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M7.5918 13.9996V4.1416' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default UpArrowIcon;
